const styles = theme => ({
  paper: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 16,
    marginTop: 8,
    boxShadow: 'none!important'
  }),
})

export default styles



// WEBPACK FOOTER //
// ./src/components/common/results/views/tdnext/styles.js